document.addEventListener("DOMContentLoaded", function (event) {

    var songs = [];

    $('.podcastplugin__track').each((index, element) => {

        var title = $(element).data('tracktitle');
        var url = $(element).data('trackurl');
        var downloadurl = $(element).data('downloadurl');
        var songindex = index + 1;

        songs.push({
          "name": title,
          "url": url
        });

        $(element).html(`
            <div class="player" id="single-song-player-${ index }">
                <div class="meta-container">

                    <div class="control-container">
                        <div class="amplitude-play-pause-custom icomoon-play" id="play-pause-${ index }" data-amplitude-song-index="${ index }"></div>
                    </div>

                    <div id="progress-container" class="progress-container"  data-amplitude-song-index="${ index }">
                        <input type="range" class="amplitude-song-slider"  data-amplitude-song-index="${ index }"/>
                        <progress class="amplitude-song-played-progress" id="song-played-progress-${ songindex }" data-amplitude-song-index="${ index }"></progress>
                    </div>

                    <div class="time-container">
                        <span class="remainig-${ index } hidden">
                           <span>-</span><span class="amplitude-time-remaining" data-amplitude-song-index="${ index }"></span>
                        </span>
                        <span class="duration-${ index }">
                           <span class="amplitude-duration-time" data-amplitude-song-index="${ index }"></span>
                        </span>
                    </div>

                    <div class="download">
                        <a class="downloadx icomoon-download" href="${ downloadurl }" download="${ title }.mp3"></a>
                    </div>

                </div>
            </div>
        `);

        document.getElementById('podcast-' + title).addEventListener('click', podcastPlayerHandler);
        document.getElementById('play-pause-' + index).addEventListener('click', podcastPlayerHandler);

        document.getElementById('song-played-progress-' + songindex).addEventListener('click', function(e){
          if( Amplitude.getActiveIndex() == index ){
            var offset = this.getBoundingClientRect();
            var x = e.pageX - offset.left;

            Amplitude.setSongPlayedPercentage( ( parseFloat(x) / parseFloat( this.offsetWidth) ) * 100 );
          }
        });

        function podcastPlayerHandler (e) {
            if (Amplitude.getActiveSongMetadata().url === url) {
                switch (Amplitude.getPlayerState()) {
                    case "playing":
                        Amplitude.pause();
                        $('#play-pause-' + index).removeClass('amplitude-playing');
                        $('.remainig-' + index).addClass('hidden');
                        $('.duration-' + index).removeClass('hidden');
                        break;
                    case "stopped":
                    case "paused":
                        Amplitude.play();
                        $('#play-pause-' + index).addClass('amplitude-playing');
                        $('.remainig-' + index).removeClass('hidden');
                        $('.duration-' + index).addClass('hidden');
                        break;
                }
            } else {
                Amplitude.pause();
                $('.amplitude-playing').removeClass('amplitude-playing');
                $('#play-pause-' + index).addClass('amplitude-playing');
                $('.remainig-' + Amplitude.getActiveIndex()).addClass('hidden');
                $('.duration-' + Amplitude.getActiveIndex()).removeClass('hidden');
                $('.remainig-' + index).removeClass('hidden');
                $('.duration-' + index).addClass('hidden');
                Amplitude.playSongAtIndex(index);
            }
        }

        function swapTime(e) {

        }
    });

    if (songs.length > 0) {
        Amplitude.init({
            "songs": songs,
            "continue_next": false,
             callbacks: {
                 ended: function(){
                    $('.amplitude-playing').removeClass('amplitude-playing');
                 }
             }
        });
    }
});



// WEBPACK FOOTER //
// ./static/js/modules/podcast.js